export default __webpack_public_path__ + "static/media/download.fde07dac.svg";